export default function Rep() {
  return (<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="15" height="15" viewBox="0 0 15 15">
    <g id="Mask_Group_261" data-name="Mask Group 261" >
      <path id="reply-message" d="M6.25,4.376V1.719a.468.468,0,0,0-.8-.336L.142,6.539a.468.468,0,0,0,0,.673l5.313,5.156a.468.468,0,0,0,.8-.336V9.375h.886a7.97,7.97,0,0,1,6.971,4.108l.013.024a.469.469,0,0,0,.411.244.463.463,0,0,0,.116-.014A.469.469,0,0,0,15,13.281,8.917,8.917,0,0,0,6.25,4.376Z" fill="#404040" />
    </g>
  </svg>)
}

